const BaseComponent = require('common/home/view');

class Home extends BaseComponent {
  constructor () {
    super();
  }
}

module.exports = Home;
